<template>
  <div class="dem-edi-pro-form" :class="demEdiProFormVerificarTamanho">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="linha-1">
        <div class='comanda-rapida' v-if="demEdiProFormMostrarCampos === false && [ '9000', '1310' ].indexOf($store.state.token.clu) !== -1 && [ 'venda_numero', 'venda_numero_pgto' ].indexOf(this.$route.name) !== -1" v-shortkey="[ 'f2' ]" @shortkey="demEdiProFormComandaRapida" data-tecla="F2" >
          <App-Button @onClick="demEdiProFormComandaRapida" :cpntDisabled="(cpntDemandaTotal !== undefined && cpntDemandaTotal.produto !== undefined && cpntDemandaTotal.produto.item !== undefined && Number(cpntDemandaTotal.produto.item) > 0)" :title="(cpntDemandaTotal !== undefined && cpntDemandaTotal.produto !== undefined && cpntDemandaTotal.produto.item !== undefined && Number(cpntDemandaTotal.produto.item) > 0) ? 'Não é possível abrir a Comanda Rápida pois já foi inserido um produto ou já existe nota emitida nesta venda.' : ''">Comanda Rápida [F2]</App-Button>
        </div>

        <App-Autocompletar :data-time="time" class="app-cpnt-field dem-edi-pro-form--item"
          :cpntStatus='campos.item.status'
          :cpntId='campos.item.id'
          :cpntTabIndex='campos.item.tabIndex'
          :cpntNome='campos.item.nome'
          :cpntValue='campos.item.value'
          :cpntMensagem='campos.item.mensagem'
          :cpntMensagemTipo='campos.item.mensagemTipo'
          :cpntDisabled='campos.item.disabled'
          :cpntMostrar='campos.item.mostrar === true'
          :cpntExplica='campos.item.explica'
          :cpntPlaceholder='campos.item.placeholder'
          :cpntValueRef='campos.item.valueRef'
          :cpntRouter='campos.item.router'
          :cpntMethod='campos.item.method'
          :cpntField='campos.item.field'
          :cpntFieldVirtual='campos.item.fieldVirtual'
          :cpntWhere='campos.item.where'
          :cpntAddButForm='campos.item.addButForm'
          :cpntKeyMostra='campos.item.keyMostra'
          :cpntTipoOrder='campos.item.tipoOrder'
          :cpntOrder='campos.item.order'
          :cpntOptions='campos.item.options'
          :cpntKeyValue='campos.item.keyValue'
          :cpntSearchMinimo='campos.item.searchMinimo'
          :cpntMask='campos.item.mask'
          :cpntNewOption='campos.item.newOption'

          :cpntOnChange='campos.item.onChange'
          :cpntOnBlur='campos.item.onBlur'
          :cpntOnRealizaBusca='campos.item.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.item.onKeyPressEnter'
          ref="item"
        ></App-Autocompletar>

        <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-form--qtde"
          :cpntStatus='campos.qtde.status'
          :cpntId='campos.qtde.id'
          :cpntTabIndex='campos.qtde.tabIndex'
          :cpntNome='campos.qtde.nome'
          :cpntValue='campos.qtde.value'
          :cpntMensagem='campos.qtde.mensagem'
          :cpntMensagemTipo='campos.qtde.mensagemTipo'
          :cpntDisabled='campos.qtde.disabled'
          :cpntMostrar='demEdiProFormMostrarCampos === true && campos.qtde.mostrar === true'
          :cpntExplica='campos.qtde.explica'
          :cpntPlaceholder='campos.qtde.placeholder'
          :cpntValueRef='campos.qtde.valueRef'
          :cpntRouter='campos.qtde.router'
          :cpntField='campos.qtde.field'
          :cpntWhere='campos.qtde.where'
          :cpntAddButForm='campos.qtde.addButForm'
          :cpntKeyMostra='campos.qtde.keyMostra'
          :cpntTipoOrder='campos.qtde.tipoOrder'
          :cpntOrder='campos.qtde.order'
          :cpntOptions='campos.qtde.options'
          :cpntKeyValue='campos.qtde.keyValue'
          :cpntSearchMinimo='campos.qtde.searchMinimo'
          :cpntMask='campos.qtde.mask'

          :cpntOnChange='campos.qtde.onChange'
          :cpntOnBlur='campos.qtde.onBlur'
          :cpntOnRealizaBusca='campos.qtde.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.qtde.onKeyPressEnter'
          ref="qtde"
        ></App-Input>
        
        <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-form--valor_uni"
            :cpntStatus='campos.valor_uni.status'
            :cpntId='campos.valor_uni.id'
            :cpntTabIndex='campos.valor_uni.tabIndex'
            :cpntNome='campos.valor_uni.nome'
            :cpntValue='campos.valor_uni.value'
            :cpntMensagem='campos.valor_uni.mensagem'
            :cpntMensagemTipo='campos.valor_uni.mensagemTipo'
            :cpntDisabled='campos.valor_uni.disabled'
            :cpntMostrar='demEdiProFormMostrarCampos === true && campos.valor_uni.mostrar === true'
            :cpntExplica='campos.valor_uni.explica'
            :cpntPlaceholder='campos.valor_uni.placeholder'
            :cpntValueRef='campos.valor_uni.valueRef'
            :cpntRouter='campos.valor_uni.router'
            :cpntField='campos.valor_uni.field'
            :cpntWhere='campos.valor_uni.where'
            :cpntAddButForm='campos.valor_uni.addButForm'
            :cpntKeyMostra='campos.valor_uni.keyMostra'
            :cpntTipoOrder='campos.valor_uni.tipoOrder'
            :cpntOrder='campos.valor_uni.order'
            :cpntOptions='campos.valor_uni.options'
            :cpntKeyValue='campos.valor_uni.keyValue'
            :cpntSearchMinimo='campos.valor_uni.searchMinimo'
            :cpntMask='campos.valor_uni.mask'

            :cpntOnChange='campos.valor_uni.onChange'
            :cpntOnBlur='campos.valor_uni.onBlur'
            :cpntOnRealizaBusca='campos.valor_uni.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_uni.onKeyPressEnter'
            ref="valor_uni"
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-form--valor_fre"
            :cpntStatus='campos.valor_fre.status'
            :cpntId='campos.valor_fre.id'
            :cpntTabIndex='campos.valor_fre.tabIndex'
            :cpntNome='campos.valor_fre.nome'
            :cpntValue='campos.valor_fre.value'
            :cpntMensagem='campos.valor_fre.mensagem'
            :cpntMensagemTipo='campos.valor_fre.mensagemTipo'
            :cpntDisabled='campos.valor_fre.disabled'
            :cpntMostrar='demEdiProFormMostrarCampos === true && campos.valor_fre.mostrar === true && demEdiProFormMostrarCampoNf === true'
            :cpntExplica='campos.valor_fre.explica'
            :cpntPlaceholder='campos.valor_fre.placeholder'
            :cpntValueRef='campos.valor_fre.valueRef'
            :cpntRouter='campos.valor_fre.router'
            :cpntField='campos.valor_fre.field'
            :cpntWhere='campos.valor_fre.where'
            :cpntAddButForm='campos.valor_fre.addButForm'
            :cpntKeyMostra='campos.valor_fre.keyMostra'
            :cpntTipoOrder='campos.valor_fre.tipoOrder'
            :cpntOrder='campos.valor_fre.order'
            :cpntOptions='campos.valor_fre.options'
            :cpntKeyValue='campos.valor_fre.keyValue'
            :cpntSearchMinimo='campos.valor_fre.searchMinimo'
            :cpntMask='campos.valor_fre.mask'

            :cpntOnChange='campos.valor_fre.onChange'
            :cpntOnBlur='campos.valor_fre.onBlur'
            :cpntOnRealizaBusca='campos.valor_fre.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_fre.onKeyPressEnter'
            ref="valor_fre"
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-form--valor_seg"
            :cpntStatus='campos.valor_seg.status'
            :cpntId='campos.valor_seg.id'
            :cpntTabIndex='campos.valor_seg.tabIndex'
            :cpntNome='campos.valor_seg.nome'
            :cpntValue='campos.valor_seg.value'
            :cpntMensagem='campos.valor_seg.mensagem'
            :cpntMensagemTipo='campos.valor_seg.mensagemTipo'
            :cpntDisabled='campos.valor_seg.disabled'
            :cpntMostrar='demEdiProFormMostrarCampos === true && campos.valor_seg.mostrar === true && demEdiProFormMostrarCampoNf === true'
            :cpntExplica='campos.valor_seg.explica'
            :cpntPlaceholder='campos.valor_seg.placeholder'
            :cpntValueRef='campos.valor_seg.valueRef'
            :cpntRouter='campos.valor_seg.router'
            :cpntField='campos.valor_seg.field'
            :cpntWhere='campos.valor_seg.where'
            :cpntAddButForm='campos.valor_seg.addButForm'
            :cpntKeyMostra='campos.valor_seg.keyMostra'
            :cpntTipoOrder='campos.valor_seg.tipoOrder'
            :cpntOrder='campos.valor_seg.order'
            :cpntOptions='campos.valor_seg.options'
            :cpntKeyValue='campos.valor_seg.keyValue'
            :cpntSearchMinimo='campos.valor_seg.searchMinimo'
            :cpntMask='campos.valor_seg.mask'

            :cpntOnChange='campos.valor_seg.onChange'
            :cpntOnBlur='campos.valor_seg.onBlur'
            :cpntOnRealizaBusca='campos.valor_seg.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_seg.onKeyPressEnter'
            ref="valor_seg"
          ></App-Input>
        </template>
        
        <div :data-time="time" class="app-cpnt-field dem-edi-pro-form--valor_des" v-show="demEdiProFormMostrarCampos === true">
          <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-form--valor_des_t" :class="demEdiProFormValorTipoDesconto === '' ? 'sem_valor' : ''"
          :cpntStatus='campos.valor_des_t.status'
          :cpntId='campos.valor_des_t.id'
          :cpntTabIndex='campos.valor_des_t.tabIndex'
          :cpntNome="demEdiProFormValorTipoDesconto === '' ? 'Tipo desconto' : 'Tipo'"
          :cpntValue='campos.valor_des_t.value'
          :cpntMensagem='campos.valor_des_t.mensagem'
          :cpntMensagemTipo='campos.valor_des_t.mensagemTipo'
          :cpntDisabled='campos.valor_des_t.disabled'
          :cpntMostrar='demEdiProFormMostrarCampos === true && campos.valor_des_t.mostrar === true'
          :cpntExplica='campos.valor_des_t.explica'
          :cpntPlaceholder='campos.valor_des_t.placeholder'
          :cpntValueRef='campos.valor_des_t.valueRef'
          :cpntRouter='campos.valor_des_t.router'
          :cpntMethod='campos.valor_des_t.method'
          :cpntField='campos.valor_des_t.field'
          :cpntWhere='campos.valor_des_t.where'
          :cpntAddButForm='campos.valor_des_t.addButForm'
          :cpntKeyMostra='campos.valor_des_t.keyMostra'
          :cpntTipoOrder='campos.valor_des_t.tipoOrder'
          :cpntOrder='campos.valor_des_t.order'
          :cpntOptions='campos.valor_des_t.options'
          :cpntKeyValue='campos.valor_des_t.keyValue'
          :cpntSearchMinimo='campos.valor_des_t.searchMinimo'
          :cpntMask='campos.valor_des_t.mask'
          :cpntOptionInicialNome='campos.valor_des_t.optionInicialNome'
          :cpntOptionInicialValue='campos.valor_des_t.optionInicialValue'
          :cpntOnBuscarOptions='campos.valor_des_t.onBuscarOptions'
          :cpntOnChange='campos.valor_des_t.onChange'
          :cpntOnBlur='campos.valor_des_t.onBlur'
          :cpntOnRealizaBusca='campos.valor_des_t.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.valor_des_t.onKeyPressEnter'
          ref="valor_des_t"
          ></App-Select>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-form--valor_des_p" :class="campos.valor_des_p.class" v-if="demEdiProFormValorTipoDesconto === '%'"
          :cpntStatus='campos.valor_des_p.status'
          :cpntId='campos.valor_des_p.id'
          :cpntTabIndex='campos.valor_des_p.tabIndex'
          :cpntClassDivField='campos.valor_des_p.classDivField'
          :cpntNome='campos.valor_des_p.nome'
          :cpntValue='campos.valor_des_p.value'
          :cpntAutoComplete='campos.valor_des_p.autocomplete'
          :cpntMask='campos.valor_des_p.mask'
          :cpntOptionInicialNome='campos.valor_des_p.optionInicialNome'
          :cpntOptionInicialValue='campos.valor_des_p.optionInicialValue'
          :cpntDisabled='campos.valor_des_p.disabled'
          :cpntMostrar='demEdiProFormMostrarCampos === true && campos.valor_des_p.mostrar === true'
          :cpntAutoFocus='campos.valor_des_p.autofocus'
          :cpntMensagem='campos.valor_des_p.mensagem'
          :cpntMensagemTipo='campos.valor_des_p.mensagemTipo'
          :cpntPlaceholder='campos.valor_des_p.placeholder'
          :cpntPosicionar='campos.valor_des_p.posicionar'
          :cpntOnChange='campos.valor_des_p.onChange'
          :cpntOnBlur='campos.valor_des_p.onBlur'
          :cpntOnKeyPressEnter='campos.valor_des_p.onKeyPressEnter'
          ref='valor_des_p'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-form--valor_des_v" :class="campos.valor_des_v.class" v-if="demEdiProFormValorTipoDesconto === 'R$'"
          :cpntStatus='campos.valor_des_v.status'
          :cpntId='campos.valor_des_v.id'
          :cpntTabIndex='campos.valor_des_v.tabIndex'
          :cpntClassDivField='campos.valor_des_v.classDivField'
          :cpntNome='campos.valor_des_v.nome'
          :cpntValue='campos.valor_des_v.value'
          :cpntAutoComplete='campos.valor_des_v.autocomplete'
          :cpntMask='campos.valor_des_v.mask'
          :cpntOptionInicialNome='campos.valor_des_v.optionInicialNome'
          :cpntOptionInicialValue='campos.valor_des_v.optionInicialValue'
          :cpntDisabled='campos.valor_des_v.disabled'
          :cpntMostrar='demEdiProFormMostrarCampos === true && campos.valor_des_v.mostrar === true'
          :cpntAutoFocus='campos.valor_des_v.autofocus'
          :cpntMensagem='campos.valor_des_v.mensagem'
          :cpntMensagemTipo='campos.valor_des_v.mensagemTipo'
          :cpntPlaceholder='campos.valor_des_v.placeholder'
          :cpntPosicionar='campos.valor_des_v.posicionar'
          :cpntOnChange='campos.valor_des_v.onChange'
          :cpntOnBlur='campos.valor_des_v.onBlur'
          :cpntOnKeyPressEnter='campos.valor_des_v.onKeyPressEnter'
          ref='valor_des_v'
          ></App-Input>
        </div>

        <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-form--valor_oda"
            :cpntStatus='campos.valor_oda.status'
            :cpntId='campos.valor_oda.id'
            :cpntTabIndex='campos.valor_oda.tabIndex'
            :cpntNome='campos.valor_oda.nome'
            :cpntValue='campos.valor_oda.value'
            :cpntMensagem='campos.valor_oda.mensagem'
            :cpntMensagemTipo='campos.valor_oda.mensagemTipo'
            :cpntDisabled='campos.valor_oda.disabled'
            :cpntMostrar='demEdiProFormMostrarCampos === true && campos.valor_oda.mostrar === true && demEdiProFormMostrarCampoNf === true'
            :cpntExplica='campos.valor_oda.explica'
            :cpntPlaceholder='campos.valor_oda.placeholder'
            :cpntValueRef='campos.valor_oda.valueRef'
            :cpntRouter='campos.valor_oda.router'
            :cpntField='campos.valor_oda.field'
            :cpntWhere='campos.valor_oda.where'
            :cpntAddButForm='campos.valor_oda.addButForm'
            :cpntKeyMostra='campos.valor_oda.keyMostra'
            :cpntTipoOrder='campos.valor_oda.tipoOrder'
            :cpntOrder='campos.valor_oda.order'
            :cpntOptions='campos.valor_oda.options'
            :cpntKeyValue='campos.valor_oda.keyValue'
            :cpntSearchMinimo='campos.valor_oda.searchMinimo'
            :cpntMask='campos.valor_oda.mask'

            :cpntOnChange='campos.valor_oda.onChange'
            :cpntOnBlur='campos.valor_oda.onBlur'
            :cpntOnRealizaBusca='campos.valor_oda.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.valor_oda.onKeyPressEnter'
            ref="valor_oda"
          ></App-Input>
        </template>

        <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-form--cms_com_id" v-if="[ 'venda' ].indexOf(cpntDemanda) !== -1"
          :cpntStatus='campos.cms_com_id.status'
          :cpntId='campos.cms_com_id.id'
          :cpntTabIndex='campos.cms_com_id.tabIndex'
          :cpntNome='campos.cms_com_id.nome'
          :cpntValue='campos.cms_com_id.value'
          :cpntMensagem='campos.cms_com_id.mensagem'
          :cpntMensagemTipo='campos.cms_com_id.mensagemTipo'
          :cpntDisabled='campos.cms_com_id.disabled'
          :cpntMostrar='demEdiProFormMostrarCampos === true && campos.cms_com_id.mostrar === true'
          :cpntExplica='campos.cms_com_id.explica'
          :cpntPlaceholder='campos.cms_com_id.placeholder'
          :cpntValueRef='campos.cms_com_id.valueRef'
          :cpntRouter='campos.cms_com_id.router'
          :cpntField='campos.cms_com_id.field'
          :cpntWhere='campos.cms_com_id.where'
          :cpntAddButForm='campos.cms_com_id.addButForm'
          :cpntKeyMostra='campos.cms_com_id.keyMostra'
          :cpntTipoOrder='campos.cms_com_id.tipoOrder'
          :cpntOrder='campos.cms_com_id.order'
          :cpntOptions='campos.cms_com_id.options'
          :cpntKeyValue='campos.cms_com_id.keyValue'
          :cpntSearchMinimo='campos.cms_com_id.searchMinimo'
          :cpntMask='campos.cms_com_id.mask'
          :cpntOptionInicialNome='campos.cms_com_id.optionInicialNome'

          :cpntOnBuscarOptions='campos.cms_com_id.onBuscarOptions'
          :cpntOnChange='campos.cms_com_id.onChange'
          :cpntOnBlur='campos.cms_com_id.onBlur'
          :cpntOnRealizaBusca='campos.cms_com_id.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.cms_com_id.onKeyPressEnter'
          ref="cms_com_id"
        ></App-Select>

        <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-form--xPed"
          :cpntStatus='campos.xPed.status'
          :cpntId='campos.xPed.id'
          :cpntTabIndex='campos.xPed.tabIndex'
          :cpntNome='campos.xPed.nome'
          :cpntValue='campos.xPed.value'
          :cpntMensagem='campos.xPed.mensagem'
          :cpntMensagemTipo='campos.xPed.mensagemTipo'
          :cpntDisabled='campos.xPed.disabled'
          :cpntMostrar='demEdiProFormMostrarCampos === true && campos.xPed.mostrar === true && demEdiProFormMostrarCampoNf === true'
          :cpntExplica='campos.xPed.explica'
          :cpntPlaceholder='campos.xPed.placeholder'
          :cpntValueRef='campos.xPed.valueRef'
          :cpntRouter='campos.xPed.router'
          :cpntField='campos.xPed.field'
          :cpntWhere='campos.xPed.where'
          :cpntAddButForm='campos.xPed.addButForm'
          :cpntKeyMostra='campos.xPed.keyMostra'
          :cpntTipoOrder='campos.xPed.tipoOrder'
          :cpntOrder='campos.xPed.order'
          :cpntOptions='campos.xPed.options'
          :cpntKeyValue='campos.xPed.keyValue'
          :cpntSearchMinimo='campos.xPed.searchMinimo'
          :cpntMask='campos.xPed.mask'

          :cpntOnChange='campos.xPed.onChange'
          :cpntOnBlur='campos.xPed.onBlur'
          :cpntOnRealizaBusca='campos.xPed.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.xPed.onKeyPressEnter'
          ref="xPed"
        ></App-Input>

        <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-form--id_pco_status" v-if="[ 'venda' ].indexOf(cpntDemanda) !== -1"
          :cpntStatus='campos.id_pco_status.status'
          :cpntId='campos.id_pco_status.id'
          :cpntTabIndex='campos.id_pco_status.tabIndex'
          :cpntNome='campos.id_pco_status.nome'
          :cpntValue='campos.id_pco_status.value'
          :cpntMensagem='campos.id_pco_status.mensagem'
          :cpntMensagemTipo='campos.id_pco_status.mensagemTipo'
          :cpntDisabled='campos.id_pco_status.disabled'
          :cpntMostrar='demEdiProFormMostrarCampos === true && campos.id_pco_status.mostrar === true'
          :cpntExplica='campos.id_pco_status.explica'
          :cpntPlaceholder='campos.id_pco_status.placeholder'
          :cpntValueRef='campos.id_pco_status.valueRef'
          :cpntRouter='campos.id_pco_status.router'
          :cpntField='campos.id_pco_status.field'
          :cpntWhere='campos.id_pco_status.where'
          :cpntAddButForm='campos.id_pco_status.addButForm'
          :cpntKeyMostra='campos.id_pco_status.keyMostra'
          :cpntTipoOrder='campos.id_pco_status.tipoOrder'
          :cpntOrder='campos.id_pco_status.order'
          :cpntOptions='campos.id_pco_status.options'
          :cpntKeyValue='campos.id_pco_status.keyValue'
          :cpntSearchMinimo='campos.id_pco_status.searchMinimo'
          :cpntMask='campos.id_pco_status.mask'
          :cpntOptionInicialNome='campos.id_pco_status.optionInicialNome'

          :cpntOnChange='campos.id_pco_status.onChange'
          :cpntOnBlur='campos.id_pco_status.onBlur'
          :cpntOnRealizaBusca='campos.id_pco_status.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.id_pco_status.onKeyPressEnter'
          ref="id_pco_status"
        ></App-Select>
        <!-- :cpntOnBuscarOptions='campos.id_pco_status.onBuscarOptions' -->

        <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-form--id_cam_seletor" v-if="cpntDemanda === 'venda' && $store.state.configuracoes.venda.doc.cfg_campo_sel === true"
          :cpntStatus='campos.id_cam_seletor.status'
          :cpntId='campos.id_cam_seletor.id'
          :cpntTabIndex='campos.id_cam_seletor.tabIndex'
          :cpntNome='campos.id_cam_seletor.nome'
          :cpntValue='campos.id_cam_seletor.value'
          :cpntMensagem='campos.id_cam_seletor.mensagem'
          :cpntMensagemTipo='campos.id_cam_seletor.mensagemTipo'
          :cpntDisabled='campos.id_cam_seletor.disabled'
          :cpntMostrar='demEdiProFormMostrarCampos === true && campos.id_cam_seletor.mostrar === true'
          :cpntExplica='campos.id_cam_seletor.explica'
          :cpntPlaceholder='campos.id_cam_seletor.placeholder'
          :cpntValueRef='campos.id_cam_seletor.valueRef'
          :cpntRouter='campos.id_cam_seletor.router'
          :cpntField='campos.id_cam_seletor.field'
          :cpntWhere='campos.id_cam_seletor.where'
          :cpntAddButForm='campos.id_cam_seletor.addButForm'
          :cpntKeyMostra='campos.id_cam_seletor.keyMostra'
          :cpntTipoOrder='campos.id_cam_seletor.tipoOrder'
          :cpntOrder='campos.id_cam_seletor.order'
          :cpntOptions='campos.id_cam_seletor.options'
          :cpntKeyValue='campos.id_cam_seletor.keyValue'
          :cpntSearchMinimo='campos.id_cam_seletor.searchMinimo'
          :cpntMask='campos.id_cam_seletor.mask'
          :cpntOptionInicialNome='campos.id_cam_seletor.optionInicialNome'
          :cpntNewOption='campos.id_cam_seletor.newOption'

          :cpntOnBuscarOptions='campos.id_cam_seletor.onBuscarOptions'
          :cpntOnChange='campos.id_cam_seletor.onChange'
          :cpntOnBlur='campos.id_cam_seletor.onBlur'
          :cpntOnRealizaBusca='campos.id_cam_seletor.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.id_cam_seletor.onKeyPressEnter'
          ref="id_cam_seletor"
        ></App-Select>
      </div>

      <div class="linha-4 botoes" v-show="demEdiProFormMostrarCampos === true">
        <App-Button :data-time='time'
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='demEdiProFormMostrarCampos === true'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClick='botoes.salvar.onClick'
        ></App-Button>

        <App-Button :data-time='time'
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='demEdiProFormMostrarCampos === true'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClick='botoes.cancelar.onClick'
        ></App-Button>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .dem-edi-pro-form {
    padding: 8px 12px 13px 12px;
    background: #efefef;
    border: 1px solid #c6c4c4;
    border-radius: 5px;
    max-width: 100%;
  }

  .dem-edi-pro-form.simplificado {
    max-width: 370px;
  }
  .dem-edi-pro-form.completo {
    max-width: 670px;
    text-align: center;
  }
  .dem-edi-pro-form.simplificado > div > .dem-edi-pro-form--item {
    width: 100%;
  }
  .dem-edi-pro-form > div {
    margin-top: -10px;
  }
  .dem-edi-pro-form.completo > div {
    width: calc(100% + 10px);
  }
  .dem-edi-pro-form > div > div:not(.comanda-rapida) {
    margin-right: 10px;
    margin-top: 25px !important;
  }
  .dem-edi-pro-form.completo > div > .dem-edi-pro-form--item {
    width: calc(60% - 10px);
  }

  .dem-edi-pro-form.completo > div > .dem-edi-pro-form--qtde,
  .dem-edi-pro-form.completo > div > .dem-edi-pro-form--valor_uni {
    width: calc(20% - 10px);
  }
  .dem-edi-pro-form > div > .dem-edi-pro-form--valor_fre,
  .dem-edi-pro-form > div > .dem-edi-pro-form--valor_seg,
  .dem-edi-pro-form > div > .dem-edi-pro-form--valor_des,
  .dem-edi-pro-form > div > .dem-edi-pro-form--valor_oda {
    width: calc(25% - 10px);
  }
  .dem-edi-pro-form > div > .dem-edi-pro-form--cms_com_id,
  .dem-edi-pro-form > div > .dem-edi-pro-form--xPed,
  .dem-edi-pro-form > div > .dem-edi-pro-form--id_pco_status {
    width: calc(33.3333% - 10px);
  }
  .dem-edi-pro-form > div > .dem-edi-pro-form--id_cam_seletor {
    width: calc(40% - 10px);
  }
  .dem-edi-pro-form > div.botoes {
    width: calc(100%);
    margin-top: 10px;
    text-align: center;
  }
    .dem-edi-pro-form > div.botoes > button {
      margin: 0px 5px;
    }
.dem-edi-pro-form > div > .comanda-rapida {
  text-align: right;
  margin-right: 0px !important;
  margin-top: 5px !important;
}
  .dem-edi-pro-form > div > .comanda-rapida > button {
    margin-top: 5px;
    padding: 5px 10px;
    float: right;
    margin-bottom: -25px;
  }  
.dem-edi-pro-form > div > .dem-edi-pro-form--valor_des {
  display: inline-block;
  text-align: left;
}
  .dem-edi-pro-form > div > .dem-edi-pro-form--valor_des > .dem-edi-pro-form--valor_des_t:not(.sem_valor) {
    width: 55px !important;
  }
  .dem-edi-pro-form > div > .dem-edi-pro-form--valor_des > .dem-edi-pro-form--valor_des_t {
    margin-right: 2px;
  }
  .dem-edi-pro-form > div > .dem-edi-pro-form--valor_des > .dem-edi-pro-form--valor_des_p {
    width: calc(100% - 57px) !important;
  }
  .dem-edi-pro-form > div > .dem-edi-pro-form--valor_des > .dem-edi-pro-form--valor_des_v {
    width: calc(100% - 57px) !important;
  }

</style>

<style>
  /*.dem-edi-pro-form > div > .dem-edi-pro-form--valor_des > .dem-edi-pro-form--valor_des_v > label {
    text-wrap: nowrap;
    margin-left: -5px;
  }*/
  .dem-edi-pro-form.completo > div > div > label {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    text-align: left;
  }

  .dem-edi-pro-form.completo > div > .dem-edi-pro-form--item > .com-new-option {
    width: 100% !important;
  }
    .dem-edi-pro-form.completo > div > .dem-edi-pro-form--item > .com-new-option ~ button {
      display: none;
    }
    .dem-edi-pro-form.completo > div > .dem-edi-pro-form--item > .com-new-option > div > input {
      border-top-right-radius: 5px !important;
      border-bottom-right-radius: 5px !important;
    }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },

      cpntPDocTp: {
        required: true
      },
      cpntVendedorDoContato: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        campos: {
          item: {
            id: 'dem-edi-pro-form--item',
            status: '',
            tabIndex: 17020001,
            nome: 'Produto (DIGITE e SELECIONE)',
            router: '/produto/get',
            method: 'POST',
            field: { id: null, codigo: null, cod_barra: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } }, id_pco_status: { j: { nome: null } }, valor_for_novo: { a: 'valor_for' }, valor_ven_novo: { a: 'valor_ven' } },
            fieldVirtual: [],
            where: 'dem-edi-pro',
            keyValue: 'id',
            keyMostra: [ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo produto' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.demEdiProFormOnNovoProduto
            },
            apiEnv: 'id_pro',
            value: '',
            valueRef: '',
            mostrar: true,
            onRealizaBusca: this.demEdiProFormOnRealizarBusca,
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          qtde: {
            id: 'dem-edi-pro-form--qtde',
            status: '',
            tabIndex: 17020002,
            nome: 'Quantidade',
            mask: 'VALOR_DECIMAL_CAMPO',
            apiEnv: 'qtde',
            value: '1,00',
            mostrar: true,
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          valor_uni: {
            id: 'dem-edi-pro-form--valor_uni',
            status: '',
            tabIndex: 17020003,
            nome: 'Valor Unitário (R$)',
            mask: 'valorDecimalNovo',
            apiEnv: 'valor_uni',
            value: '',
            mostrar: true,
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          valor_fre: {
            id: 'dem-edi-pro-form--valor_fre',
            status: '',
            tabIndex: 17020004,
            nome: 'Valor Frete (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_fre',
            value: '',
            mostrar: true,
            explica: { mensagem: 'Insira o valor total do frete (este valor não será mutiplicado pela quantidade)' },
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          valor_seg: {
            id: 'dem-edi-pro-form--valor_seg',
            status: '',
            tabIndex: 17020005,
            nome: 'Valor Seguro (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_seg',
            value: '',
            mostrar: true,
            explica: { mensagem: 'Insira o valor total do seguro (este valor não será mutiplicado pela quantidade)' },
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          valor_des: {
            id: 'dem-edi-pro-form--valor_des',
            status: '',
            tabIndex: 17020006,
            nome: 'Valor Desconto (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_des',
            value: '',
            mostrar: true,
            explica: { mensagem: 'Insira o valor total do desconto (este valor não será mutiplicado pela quantidade)' },
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          valor_des_v: {
            id: 'dem-edi-pro-form--valor_des_v',
            status: '',
            tabIndex: 17020006,
            nome: 'Valor desconto',
            value: '',
            mostrar: true,
            mask: 'valorMoeda',
            apiEnv: 'valor_des_fixo',
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          valor_des_p: {
            id: 'dem-edi-pro-form--valor_des_p',
            status: '',
            tabIndex: 17020006,
            nome: '% desconto',
            value: '',
            mostrar: true,
            mask: 'valorDecimalNovo',
            apiEnv: 'valor_des_por',
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          valor_des_t: {
            id: 'dem-edi-pro-form--valor_des_t',
            status: '',
            tabIndex: 17020006,
            options: [
              { id: 'R$', api: 'valor' },
              { id: '%', api: 'porcentagem' }
            ],
            keyMostra: [ 'id' ],
            keyValue: 'id',
            nome: 'Tipo',
            value: '',
            mostrar: true,
            mask: '',
            explica: { mensagem: 'Tipo de desconto' },
            onChange: this.demEdiProFormOnChangeValue
          },
          valor_oda: {
            id: 'dem-edi-pro-form--valor_oda',
            status: '',
            tabIndex: 17020007,
            nome: 'Valor O.D.A. (R$)',
            mask: 'valorMoeda',
            apiEnv: 'valor_oda',
            value: '',
            mostrar: true,
            explica: { mensagem: 'Insira o valor total de outras despesas acessórias (este valor não será mutiplicado pela quantidade)', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          cms_com_id: {
            id: 'dem-edi-pro-form--cms_com_id',
            status: '',
            tabIndex: 17020008,
            nome: 'Vendedor',
            keyValue: 'id_con',
            keyMostra: [ 'id_con', ' - ', 'id_con_nome' ],
            options: [],
            value: '',
            apiEnv: 'cms_com_id',
            mostrar: true,
            onBuscarOptions: this.demEdiProFormOnBuscarVendedores,
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },

          xPed: {
            id: 'dem-edi-pro-form--xPed',
            status: '',
            tabIndex: 17020009,
            nome: 'Nº do Pedido',
            explica: { mensagem: 'Número do Pedido de Compra' },
            value: '',
            apiEnv: 'xPed',
            mostrar: true,
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          id_pco_status: {
            id: 'dem-edi-pro-form--id_pco_status',
            status: '',
            tabIndex: 17020010,
            nome: 'Lista de processo',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            optionInicialNome: 'Não utilizar',
            value: '',
            apiEnv: 'id_pco_status',
            mostrar: true,
            // onBuscarOptions: this.demEdiProFormOnBuscarListaPco,
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          id_cam_seletor: {
            id: 'dem-edi-pro-form--id_cam_seletor',
            status: '',
            tabIndex: 17020010,
            nome: 'Campo Seletor',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            optionInicialNome: 'Não utilizar',
            value: '',
            apiEnv: 'id_cam_seletor',
            mostrar: true,
            newOption: true,
            onBuscarOptions: this.demEdiProFormOnBuscarCampoSeletor,
            onChange: this.demEdiProFormOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          }
        },
        botoes: {
          salvar: {
            status: '',
            tabIndex: 17020011,
            id: 'dem-edi-pro-form--salvar',
            texto: 'Inserir produto',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.demEdiProFormInserir() }
          },
          cancelar: {
            status: '',
            tabIndex: 17020099,
            id: 'dem-edi-pro-form--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: this.demEdiProFormCancelar
          }
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.demEdiProFormSetarStatusGeral('carregando')

      // INICIAR CARREGAMENTO
      this.demEdiProFormIniciar()
    },
    methods: {
      demEdiProFormIniciar: function () {
        // VERIFICA AS LICENÇAS DE USO QUE DEVE MUDAR A PESQUISA
        if ([ '3126', '3154', '3155', '9122', '9123', '9124', '3332', '3333', '3335', '3336', '3337', '3338', '3339' ].indexOf(this.$store.state.token.clu) !== -1) {
          // SETA OS CAMPOS QUE DEVE MOSTRAR NO AUTO COMPLITE
          this.campos.item.field = Object.assign(this.campos.item.field, {
            id_for: { j: { nome: null } }
          })

          // SETA O MODO DE EXIBIÇÃO
          if (this.cpntDemanda === 'venda') {
            this.campos.item.keyMostra = [ 'nome', ' - R$ ', 'valor_ven', ' - ', 'id_for_nome', ' - ', 'codigo' ]
          } else if (this.cpntDemanda === 'compra') {
            this.campos.item.keyMostra = [ 'nome', ' - R$ ', 'valor_for', ' - ', 'id_for_nome', ' - ', 'codigo' ]
          }

          // SETA O WHERE QUE DEVE REALIZAR
          this.campos.item.where = {
            aAnd: [
              { f: 'status', o: '=', v: '1' },
              { aOr: [
                { f: 'nome', o: 'locate', v: '#BUSCA#' },
                { f: 'codigo', o: 'locate', v: '#BUSCA#' },
                { f: 'cod_barra', o: 'locate', v: '#BUSCA#' },
                { f: 'nome', o: 'locate', v: '#BUSCA#' }
              ] }
            ]
          }
        }

        // VERIFICA SE TEM QUE MOSTRAR O CONTROLE DE PROCESSOS
        this.campos.id_pco_status.mostrar = this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true

        // VERIFICA SE TEM CONTROLE DE COMISSÕES
        this.campos.cms_com_id.mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === true

        if(this.campos.id_pco_status.mostrar) {

          this.demEdiProFormOnBuscarListaPco()
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DA PAGINA
        this.demEdiProFormSetarStatusGeral('')
      },
      demEdiProFormSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProFormSetarVendedor: function () {
        // PEGA O VALOR
        var valor = JSON.parse(JSON.stringify(this.cpntVendedorDoContato))

        // SETA O VALOR RECEBIDO
        this.campos.cms_com_id.value = [ '', null, undefined, '0', 0 ].indexOf(valor.id_con) === -1 ? valor : ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProFormOnRealizarBusca: function () {
        // LIMPA O CAMPO, PARA FECHAR OS FORMULARIOS
        this.campos.item.value = ''
        this.campos.item.valueRef = ''

        // SETA OS VALORES INICIAIS
        this.campos.qtde.value = '1,00'
        this.campos.valor_uni.value = '0'
        this.campos.valor_fre.value = '0'
        this.campos.valor_seg.value = '0'
        this.campos.valor_des_t.value = { id: 'R$' }
        this.campos.valor_des_p.value = ''
        this.campos.valor_des_v.value = ''
        this.campos.valor_oda.value = '0'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProFormOnNovoProduto: function (nome) {
        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'produto', id: 0, nome: nome }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            this.demEdiProFormOnChangeValue(dados, this.campos.item.id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      demEdiProFormOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // VERIFICA SE É UM INSERT DIRETO
        if (index !== 'item' || value.__INSERT_VALUE__ !== true) {
          // SETA O VALOR RECEBIDO
          this.campos[index].value = value

          // REMOVE A MENSAGEM DE ERRO
          this.campos[index].mensagem = ''
          this.campos[index].mensagemTipo = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // VERIFICA SE TEM QUE PERSONALIZAR ALGUMA COISA
        switch (index) {
          case 'item':
            // FORMATA OS VALORES RECEBIDOS
            if ([ '', null, undefined ].indexOf(value.valor_for) === -1) {
              value.valor_for = Number(value.valor_for).toString()
            }
            if ([ '', null, undefined ].indexOf(value.valor_ven) === -1) {
              value.valor_ven = Number(value.valor_ven).toString()
            }

            // PEGA O VALOR QUE DEVE SETAR NO CAMPO
            var valorUni = [ 'venda', 'dem_dev_cliente', 'dem_dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1 ? value.valor_ven : value.valor_for

            // FAZ A SEPARAÇÃO PARA VERIFICAÇÃO
            valorUni = valorUni.split('.')

            // FORMATA O VALOR RECEBIDO
            if (valorUni[valorUni.length -1].length >= 3) {
              // SETA QUE DEVE USAR MASCARA DECIMAL
              this.$refs.valor_uni.usarDecimal = true

              // FORMATA O VALOR RECEBIDO
              valorUni = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', valorUni.join('.'))
            } else {
              // SETA QUE DEVE USAR MASCARA DECIMAL
              this.$refs.valor_uni.usarDecimal = false

              // ADICIONA UM ZERO NO FINAL
              if (valorUni.length === 1) {
                valorUni.push('00')
              } else if (valorUni[(valorUni.length - 1)].length === 1) {
                valorUni[(valorUni.length - 1)] = (valorUni[(valorUni.length - 1)].toString() + '0')
              }

              // FORMATA O VALOR RECEBIDO
              valorUni = this.$store.state.FUN_MASK_VALOR('valorMoeda', valorUni.join(''))
            }

            // VERIFICA SE DEVE INSERIR OU NÃO O VALOR
            if (value.__INSERT_VALUE__ === true) {
              // INICIA O FORMULARIO QUE DEVE SER PREENCHIDO
              var formData = {}

              // SETA O ID DO PRODUTO A SER INSERIDO
              formData.id_pro = value.id

              // SETA O CAMPO QUANTIDADE
              formData.qtde = '1'

              // SETA O VALOR UNITARIO DO PRODUTO
              formData.valor_uni = valorUni

              // REMOVE O PONTO
              while (formData.valor_uni.indexOf('.') !== -1) {
                formData.valor_uni = formData.valor_uni.replace('.', '')
              }
              // ALTERA A VIRGULA PARA PONTO
              formData.valor_uni = formData.valor_uni.replace(',', '.')

              // VERIFICA SE É UM VALOR VALIDO PARA O ITEM
              if ([ '', null, undefined, '00', '000' ].indexOf(formData.valor_uni) !== -1) {
                formData.valor_uni = '0'
              }

              // VERIFICA SE TEM QUE SETAR A LISTA DE STATUS
              if ([ '', null, undefined ].indexOf(value.id_pco_status) === -1) {
                formData.id_pco_status = value.id_pco_status
              }

              // VERIFICA SE TEM QUE SETAR A LISTA DE STATUS
              if ([ '', null, undefined ].indexOf(this.cpntVendedorDoContato) === -1 && [ '', null, undefined, '0', 0 ].indexOf(this.cpntVendedorDoContato.id_con) === -1) {
                formData.cms_com_id = this.cpntVendedorDoContato.id_con
              }

              // CHAMA A FUNÇÃO PARA INSERT DO ITEM
              this.demEdiProFormInserir(formData)
            } else {
              // QUEBRA O SINCRONISMO DO VUE
              value = JSON.parse(JSON.stringify(value))

              // SETA O VALOR DO CAMPO
              this.campos[index].value = value
              this.campos[index].valueRef = value.id

              // SETA O VALOR DE VENDA RECEBIDO DO PRODUTO
              this.campos.valor_uni.value = valorUni
              // if ([ 'compra' ].indexOf(this.cpntDemanda) !== -1 && [ '', null, undefined ].indexOf(value.valor_for) === -1) {
              //   this.campos.valor_uni.value = value.valor_for
              // } else if ([ 'venda', 'dem_dev_cliente' ].indexOf(this.cpntDemanda) !== -1 && [ '', null, undefined ].indexOf(value.valor_ven) === -1) {
              //   this.campos.valor_uni.value = value.valor_ven
              // }

              // INICIA O VALOR DO CONTROLE DE PROCESSO DO ITEM
              // var valorPCO = ''

              // // VERIFICA SE TEM QUE SETAR A LISTA DE STATUS
              // if ([ '', null, undefined ].indexOf(value.id_pco_status) === -1) {
              //   valorPCO = { id: value.id_pco_status, nome: value.id_pco_status_nome }
              // }

              // // SETA O VALOR RECEBIDO
              // this.campos.id_pco_status.value = valorPCO

              if(this.campos.id_pco_status.value.id === '') {

                // if(this.$store.state.configuracoes.produto.est.cfg_id_pco_status !== '')
                this.campos.id_pco_status.value = this.$store.state.configuracoes.produto.est.cfg_id_pco_status

              }  

              // CHAMA A FUNÇÃO PARA ATUALIZAR O COMISSIONADO
              this.demEdiProFormSetarVendedor()

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
  
              // CHAMA A FUNÇÃO PARA DAR FOCUS NO PROXIMO CAMPO
              this.demEdiProFormRealizarFocus(index)
            }
            break

          case 'cms_com_id':
            // SETA O VALOR RECEBIDO
            this.campos[index].value = value

            // ATUALIZA O VENDEDOR SELECIONADO
            this.$parent.$emit('DEMANDA_ALTERAR_VENDEDOR', value)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break

          case 'id_pco_status':
            // SETA O VALOR RECEBIDO
            this.campos[index].value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break

          case 'id_cam_seletor':
            if (value.id === '__NOVO_OPTION__') {
              this.demEdiProFormSalvarCampoSeletor(value)
            }
            break

          case 'valor_des_t':
            this.demEdiProFormRealizarFocus('valor_des_t')
            break
        }
      },
      demEdiProFormOnKeyPressEnter: function (id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // CHAMA A FUNÇÃO PARA DAR FOCUS NO PROXIMO CAMPO
        this.demEdiProFormRealizarFocus(index)
      },
      demEdiProFormFormatarNumeroSalvar: function (valor) {
        // PEGA O VALOR RECEBIDO
        valor = JSON.parse(JSON.stringify(valor)).toString()

        // CONVERTE A VIRGULA EM PONTO
        valor = valor.replace(',', '.')

        // CONVERTE A STRING EM NUMERO
        return valor.toString()
      },
      demEdiProFormInserir: function (formData = null) {
        // SETA O STATUS DE CARREGANDO
        this.botoes.salvar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE RECEBEU O FORMULARIO A SER SALVO
        if (formData === null) {
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API
  
          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_MONTAR_FORMDATA_API(this.campos, this).then((formData) => { this.demEdiProFormInserir(formData) }).catch(this.demEdiProFormSetarStatusGeral)
        } else {
          // // VERIFICA SE DEVE FORMATAR O CAMPO
          // if (this.cpntDemanda !== 'compra' && [ '', null, undefined ].indexOf(formData.valor_uni) === -1) {
          //   // REMOVE O PONTO
          //   while (formData.valor_uni.indexOf('.') !== -1) {
          //     formData.valor_uni = formData.valor_uni.replace('.', '')
          //   }
          //   // REMOVE A VIRGULA
          //   while (formData.valor_uni.indexOf(',') !== -1) {
          //     formData.valor_uni = formData.valor_uni.replace(',', '')
          //   }
          // }

          // VERIFICA SE DEVE MANDAR NULL PARA API
          if ([ '', null, undefined ].indexOf(formData.cms_com_id) !== -1) {
            formData.cms_com_id = null
          }

          // REMOVE O CAMPO SE NÃO TIVER O CAMPO CONTRATADO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === false) {
            delete formData.cms_com_id
          }

          // REMOVE O CAMPO SE NÃO TIVER O CAMPO CONTRATADO
          if ((this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true) == false) {
            delete formData.id_pco_status
          }

          // VERIFICA SE TEM O CAMPO ATIVADO
          if (this.cpntDemanda !== 'venda' || (this.cpntDemanda === 'venda' && this.$store.state.configuracoes.venda.doc.cfg_campo_sel === false)) {
            delete formData.id_cam_seletor
          }

          // CAMPOS NÃO IMPLEMENTADOS AINDA
          // formData.p_icms_st_v = '0.00'
          // formData.p_ipi_v = 0

          // INICIA A VARIAVEL
          var router = ''

          // SETA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'venda':
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/venda/produto'

              // SETA O ID DA DEMANDA QUE DEVE SALVAR
              formData.cod_venda = this.cpntDemandaId
              break

            case 'compra':
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/demanda/dem-compra/dem-produto'

              // SETA O ID DA DEMANDA QUE DEVE SALVAR
              formData.dem_compra = this.cpntDemandaId
              break
          }

          // DELETE A CHAVE SE NÃO TIVER VALOR VALIDO
          if ([ '', null, undefined, 0, '0', '0,', '0,0', '0,00' ].indexOf(formData.valor_des_por) !== -1) {
            delete formData.valor_des_por
          } else {
            // REMOVE A FORMATAÇÃO 
            if (isNaN(formData.valor_des_por) !== false) {
              // REMOVE OS PONTOS DA STRING
              while (formData.valor_des_por.indexOf('.') !== -1) {
                formData.valor_des_por = formData.valor_des_por.replace('.', '')
              }
              // REMOVE A VIRGULA DA STRING
              while (formData.valor_des_por.indexOf(',') !== -1) {
                formData.valor_des_por = formData.valor_des_por.replace(',', '.')
              }
            }
          }
          if ([ '', null, undefined, 0, '0', '0,', '0,0', '0,00' ].indexOf(formData.valor_des_fixo) !== -1) {
            delete formData.valor_des_fixo
          } else {
            // REMOVE A FORMATAÇÃO 
            if (isNaN(formData.valor_des_fixo) !== false) {
              // REMOVE OS PONTOS DA STRING
              while (formData.valor_des_fixo.indexOf('.') !== -1) {
                formData.valor_des_fixo = formData.valor_des_fixo.replace('.', '')
              }
              // REMOVE A VIRGULA DA STRING
              while (formData.valor_des_fixo.indexOf(',') !== -1) {
                formData.valor_des_fixo = formData.valor_des_fixo.replace(',', '.')
              }
            }

            // CONVERTE VALOR EM DECIMAL
            formData.valor_des_fixo = (Number(formData.valor_des_fixo) / 100).toString()
          }

          // REMOVE A CHAVE DESCONTO
          if (this.cpntDemanda === 'venda' && formData.valor_des !== undefined) {
            delete formData.valor_des
          }

          // CONVERTE O VALOR RECEBIDO
          formData.valor_uni_novo = formData.valor_uni

          // REMOVE A CHAVE NÃO UTILIZADA
          delete formData.valor_uni

          // CONVERTE O VALOR EM LOT
          formData = { lot: [ formData ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'POST', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
      
                // MANDA ATUALIZAR A TABELA
                this.$emit('DEMANDA_UPDATE_TABELA')

                // ATUALIZA OS DADOS E DESTRAVA A TELA
                this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                  // LIMPA O FORMULARIO
                  this.demEdiProFormCancelar()

                  // DESTRAVA A TELA
                  this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
                })
                break

              default:
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, this.campos, true, (campos) => {
                  // SETA OS CAMPOS COM OS ERROS
                  this.campos = campos

                  // MANDA ATUALIZAR A TABELA
                  this.$emit('DEMANDA_UPDATE_TABELA')

                  // ATUALIZA OS DADOS E DESTRAVA A TELA
                  this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                    // LIMPA O FORMULARIO
                    this.demEdiProFormCancelar()

                    // SETA O STATUS DA TELA
                    this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
                  })
                })
                break
            }
          }, this.demEdiProFormSetarStatusGeral, (apiValid, apiStatus) => {
            this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, this.campos, true, (campos) => {
              // SETA OS CAMPOS COM OS ERROS
              this.campos = campos

              // MANDA ATUALIZAR A TABELA
              this.$emit('DEMANDA_UPDATE_TABELA')

              // ATUALIZA OS DADOS E DESTRAVA A TELA
              this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                // LIMPA O FORMULARIO
                this.demEdiProFormCancelar()

                // SETA O STATUS DA TELA
                this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
              })
            })
          })
        }
      },
      demEdiProFormCancelar: function () {
        // LIMPA O CAMPO, PARA FECHAR OS FORMULARIOS
        setTimeout(() => {
          this.campos.item.value = ''
          this.campos.item.valueRef = ''
          this.$refs.item.value = ''
          this.$refs.item.busca = ''
          this.$refs.item.$refs.autocompletar.setValue('')
          this.$refs.item.$refs.autocompletar.$refs.input.value = ''
  
          // SETA OS VALORES INICIAIS
          this.campos.qtde.value = '1,00'
          this.campos.valor_uni.value = '0'
          this.campos.valor_fre.value = '0'
          this.campos.valor_seg.value = '0'
          this.campos.valor_des_t.value = { id: 'R$' }
          this.campos.valor_des_p.value = ''
          this.campos.valor_des_v.value = ''
          this.campos.valor_oda.value = '0'

          // SETA O STATUS DE CARREGANDO
          this.botoes.salvar.status = ''
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
  
          // SETA O FOCUS NO CAMPO
          setTimeout(() => { this.$refs.item.$refs.autocompletar.$refs.input.select() }, 0)
        }, 0)
      },
      demEdiProFormRealizarFocus: function (index) {
        switch (index) {
          case 'item':
            this.demEdiProFormRealizarFocusCampo('qtde')
            break

          case 'qtde':
            this.demEdiProFormRealizarFocusCampo('valor_uni')
            break

          case 'valor_uni':
            this.demEdiProFormInserir()
            break

          case 'valor_fre':
            this.demEdiProFormRealizarFocusCampo('valor_seg')
            break

          case 'valor_seg':
            this.demEdiProFormRealizarFocusCampo('valor_des_t')
            break

          case 'valor_des_t':
            this.demEdiProFormRealizarFocusCampo('valor_des_p')
            break

          case 'valor_des_p':
            this.demEdiProFormRealizarFocusCampo('valor_des_v')
            break

          case 'valor_des_v':
            this.demEdiProFormRealizarFocusCampo('valor_oda')
            break

          case 'valor_oda':
            this.demEdiProFormRealizarFocusCampo('cms_com_id')
            break

          case 'cms_com_id':
            this.demEdiProFormRealizarFocusCampo('xPed')
            break

          case 'xPed':
            this.demEdiProFormRealizarFocusCampo('id_pco_status')
            break

          case 'id_pco_status':
            this.demEdiProFormInserir()
            break
        }
      },
      demEdiProFormRealizarFocusCampo: function (chave, tentativa = 0) {
        if (this.$store.state.mobile === false) {
          if (tentativa <= 5) {
            if (this.campos[chave].mostrar === true && [ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
              this.$refs[chave].cpntRealizarFocus()
            } else {
              setTimeout(() => { this.demEdiProFormRealizarFocusCampo(chave, (tentativa + 1)) }, 100)
            }
          } else {
            this.demEdiProFormRealizarFocus(chave)
          }
        }
      },
      demEdiProFormOnBuscarVendedores: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id_con: { j: { nome: null } } }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'status', o: '=', v: '1' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/comissao/config/comissionado/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProFormOnBuscarVendedores(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.cms_com_id.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.cms_com_id.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProFormOnBuscarListaPco: function (/*callback, id, */total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, order: { nome: 'asc' } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'status', o: '=', v: '1' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/con-processo/config/status/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProFormOnBuscarListaPco(/*callback, id, */Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_pco_status.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_pco_status.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          //callback()
        }
      },
      demEdiProFormOnBuscarCampoSeletor: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.order = { nome: 'asc' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/venda/cam-seletor/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProFormOnBuscarCampoSeletor(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_cam_seletor.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_cam_seletor.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_cam_seletor.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProFormSalvarCampoSeletor: function (option) {
        // INICIA AS VARIAVEIS
        var formData = { nome: option._text }

        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/venda/cam-seletor', 'POST', formData, (retorno) => {
          // LIMPA OS OPTIONS PARA BUSCAR NOVAMENTE AO ABRIR O CAMPO
          this.campos.id_cam_seletor.options = []
          this.campos.id_cam_seletor.value = { id: retorno.ref.id, nome: option.nome }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(retorno)
        }, this.demEdiProFormSetarStatusGeral, (apiValid, apiStatus) => {
          // VERIFICA SE TEM QUE CONVERTER O CAMPO
          if ([ '', null, undefined ].indexOf(apiValid.nome) === -1) {
            // SETA O VALOR NO NOVO CAMPO
            apiValid.id_cam_seletor = apiValid.nome

            // REMOVE O CAMPO ANTIGO PARA NÃO APRESENTAR DUAS VEZES
            delete apiValid.id_cam_seletor
          }

          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this)
        })
      },
      demEdiProFormComandaRapida: function () {
        this.$emit('APP_COMANDA_RAPIDA')
      }
    },
    computed: {
      demEdiProFormMostrarCampos: function () {
        return this.campos.item.value !== ''
      },
      demEdiProFormMostrarCampoNf: function () {
        return [ 'NFe', 'NFCe' ].indexOf(this.cpntPDocTp) !== -1
      },
      demEdiProFormVerificarTamanho: function () {
        return this.campos.item.valueRef !== '' ? 'completo' : 'simplificado'
      },
      demEdiProFormValorTipoDesconto: function () {
        return (typeof this.campos.valor_des_t.value === 'string' ? this.campos.valor_des_t.value : this.campos.valor_des_t.value.id)
      }
    }
  }
</script>
